import {
  Button,
  createStyles,
  LinearProgress,
  Typography,
  withStyles,
} from '@material-ui/core';
import type { LaunchPadData } from '@mogul/api-client';
import { Network } from '@mogul/api-client';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import { ReactComponent as BSCIcn } from '../../common/svg/general/bsc-logo.svg';
import ethIcn from '../../common/svg/general/eth-icon.svg';
import starsIcn from '../../common/svg/general/star-icon.svg';
import checkmarkCircle from '../../common/svg/launchpad/checkmarkCircle.svg';
import discordIcn from '../../common/svg/launchpad/icon-discord.svg';
import globeIcn from '../../common/svg/launchpad/icon-globe.svg';
import twitterIcn from '../../common/svg/launchpad/icon-twitter.svg';
import multiplyCircle from '../../common/svg/launchpad/multiplyCircle.svg';
import notifIcn from '../../common/svg/launchpad/notif-icon.svg';
import { getMonthEnglish, getPrettyDayTime } from '../../utils/date.util';
import { getProof } from '../../utils/merkleTree.util';
import { Button as CoreButton } from '../core/button/Button';
import { LaunchpadCountDown } from './LaunchpadCountDown.component';
import styles from './LaunchpadMinting.module.css';

const BorderLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 20,
      borderRadius: 15,
    },
    colorPrimary: {
      backgroundColor: '#798399',
    },
    bar: {
      borderRadius: 15,
      backgroundColor: '#ffffff',
    },
  }),
)(LinearProgress);
export interface Props {
  launchPadData: LaunchPadData | undefined;
  startDate: Date;
  preSaleDate: Date;
  saleEndDate: Date;
  preSales: number;
  MetaMaskModal?: any;
  SetMintingModal?: any;
  SignupModal?: any;
  WrongNetworkModal?: any;
  history?: any;
  walletInfo?: any;
  setModal?: any;
}

export const LaunchpadMinting: React.FC<Props> = props => {
  const [mintAmount, setMintAmount] = useState<number>(1);
  const [hideProgressBar, setHideProgressBar] = useState<boolean>(false);
  const {
    MetaMaskModal,
    SetMintingModal,
    SignupModal,
    WrongNetworkModal,
    history,
    setModal,
    walletInfo,
    launchPadData,
  } = props;

  const [dropStart, setDropStart] = useState<boolean>(false);
  const [saleEnd, setSaleEnd] = useState<boolean>(false);
  const [whitelist, setWhiteList] = useState<string[]>([]);
  const [communityInfos, setCommunityInfos] = useState<any>({});
  const [dateLabel, setDateLabel] = useState<string>();

  useEffect(() => {
    const newWhiteList = [];
    if (props.launchPadData?.whiteListedAddresses) {
      for (const walletData of props.launchPadData.whiteListedAddresses) {
        newWhiteList.push(walletData.address);
      }
      setWhiteList(newWhiteList);
    }
  }, [props.launchPadData]);

  useEffect(() => {
    setCommunityInfos(props.launchPadData?.communityInfo);

    const myfunc = setInterval(function () {
      const now = new Date().getTime();
      const timeleft = props.startDate.getTime() - now;
      const preSaleTimeleft = props.preSaleDate.getTime() - now;
      const saleEndTimeleft = props.saleEndDate.getTime() - now;

      if (isNaN(preSaleTimeleft) || preSaleTimeleft <= 0) {
        setDateLabel('Offical Sale Start');
      } else {
        setDateLabel('Pre-Sale Start');
      }

      if (timeleft <= 0) {
        clearInterval(myfunc);
        setDropStart(true);
      }

      if (saleEndTimeleft <= 0) {
        clearInterval(myfunc);
        setDateLabel('Sale Ended');
        setSaleEnd(true);
      }

      if (
        preSaleTimeleft <= 0 &&
        whitelist.includes(walletInfo?.walletAddress)
      ) {
        setDropStart(true);
      }
    }, 1000);
  }, [
    props.launchPadData,
    props.startDate,
    props.preSaleDate,
    props.saleEndDate,
    props.preSales,
    whitelist,
    walletInfo?.walletAddress,
  ]);

  useEffect(() => {
    const app = document.querySelector<HTMLElement>('.app-container');

    const initalViewPortWidth = window.innerWidth;

    if (initalViewPortWidth <= 1280) {
      setHideProgressBar(true);
    }

    const onResize = () => {
      const viewPortWidth = window.innerWidth;

      if (viewPortWidth > 1280) {
        setHideProgressBar(false);
      } else {
        setHideProgressBar(true);
      }
    };

    if (app) {
      window.addEventListener('resize', onResize, { passive: true });
      return () => {
        window.removeEventListener('resize', onResize);
      };
    }
  }, []);

  const decreaseAmount = () => {
    if (mintAmount > 1) {
      setMintAmount(mintAmount - 1);
    }
  };

  const increaseAmount = () => {
    if (
      (props.launchPadData?.maxNftPurchasePresale != null &&
        mintAmount < props.launchPadData.maxNftPurchasePresale) ||
      (props.launchPadData?.collection?.maxMintsPerTxGlobal !== null &&
        props.launchPadData?.collection?.maxMintsPerTxGlobal !== undefined &&
        mintAmount <
          parseFloat(props.launchPadData.collection.maxMintsPerTxGlobal))
    ) {
      setMintAmount(mintAmount + 1);
    }
  };

  const navigateToRegister = () => {
    history.push(`/register`);
  };

  const mint = () => {
    const network = window.location.href.includes(
      'https://film3.mogulproductions.com/',
    )
      ? Network.Mainnet
      : Network.Rinkeby;
    if (walletInfo?.walletAddress === '') {
      setModal(MetaMaskModal());
    } else if (
      ![network, Network.Goerli].includes(walletInfo?.currentNetwork)
    ) {
      setModal(WrongNetworkModal(walletInfo?.currentNetwork, network));
    } else {
      const timeleft = props.startDate.getTime() - new Date().getTime();

      let proof: any[] = [];

      // If we are in regular sale mode, whitelisting is not necessary
      if (Date.now() < props.startDate.getTime()) {
        proof = getProof(whitelist, walletInfo?.walletAddress);
      }

      const targetNetwork = [Network.Goerli].includes(
        walletInfo?.currentNetwork,
      )
        ? walletInfo.currentNetwork
        : network;

      setModal(
        SetMintingModal(
          props.launchPadData?.collection?.contractAddress,
          mintAmount.toString(),
          props.launchPadData?.maxNftPurchasePresale !== undefined
            ? props.launchPadData.maxNftPurchasePresale
            : 1,
          targetNetwork,
          props.launchPadData?.mintPrice,
          props.launchPadData?.currency,
          timeleft <= 0 ? false : true,
          proof,
          launchPadData,
        ),
      );
    }
  };

  const notify = () => {
    setModal(
      SignupModal(
        navigateToRegister,
        props.launchPadData?.collection?.contractAddress,
        props.launchPadData?.collection?.network,
      ),
    );
  };

  const viewCollection = () => {
    history.push(
      `/platform/collection/eth/${props.launchPadData?.collection?.slug}`,
    );
  };

  const goToMarketplace = () => {
    history.push(`/platform/marketplace`);
  };

  // price ratios
  const [starsToUsdRatio, setStarsToUsdRatio] = useState(1);
  const [ethToUsdRatio, setEthToUsdRatio] = useState(1);
  const [bnbToUsdRatio, setBnbToUsdRatio] = useState(1);
  const getRatios = async () => {
    try {
      const { data: starsToUsd } = await axios.get(
        'https://api.coingecko.com/api/v3/simple/price?ids=mogul-productions-2&vs_currencies=usd',
      );
      const { data: ethToUsd } = await axios.get(
        'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd',
      );
      const { data: bnbToUsd } = await axios.get(
        'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd',
      );
      setStarsToUsdRatio(starsToUsd['mogul-productions-2']['usd']);
      setEthToUsdRatio(ethToUsd['ethereum']['usd']);
      setBnbToUsdRatio(bnbToUsd['binancecoin']['usd']);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    void (async () => {
      await getRatios();
    })();
  }, []);

  const defaultStarsPrice = props.launchPadData?.mintPrice
    ? props.launchPadData.mintPrice[
        props.launchPadData.currency.indexOf('STARS')
      ]
    : 0;

  const tkType = launchPadData?.collection?.tokenType;
  const pricingStrategy =
    launchPadData?.collection?.saleStrategy ?? 'Simplified';
  const tiers = launchPadData?.collection?.pricingRules ?? [];

  const ERC115MintableDefaultCurrencies =
    launchPadData?.collection?.mintCurrency;
  const ERC115MintableDefaultPrices = launchPadData?.collection?.mintPrice;

  const ERC1155MintableCurrencyTarget =
    pricingStrategy === 'Tiered'
      ? tiers[0].tokens
      : ERC115MintableDefaultCurrencies;

  const ERC1155MintablePricesTarget =
    pricingStrategy === 'Tiered'
      ? tiers[0].prices
      : ERC115MintableDefaultPrices;

  const defaultPrice = props.launchPadData?.mintPrice ?? 0;

  const paymentPrices: string[] | number[] | undefined =
    tkType === 'ERC1155 Mintable'
      ? ERC1155MintablePricesTarget
      : typeof defaultPrice === 'number'
      ? [defaultPrice.toString()]
      : defaultPrice;

  const paymentCurrencies: string[] | undefined =
    tkType === 'ERC1155 Mintable'
      ? ERC1155MintableCurrencyTarget
      : props.launchPadData?.currency;

  const defaultNativePrice = props.launchPadData?.mintPrice
    ? props.launchPadData.mintPrice[props.launchPadData.currency.indexOf('ETH')]
    : 0;

  const simplifiedPrice =
    props.launchPadData?.collection?.mintPrice &&
    props.launchPadData.collection.mintCurrency
      ? props.launchPadData.collection.mintPrice[
          props.launchPadData.collection.mintCurrency.indexOf('STARS')
        ]
      : 0;

  const indexOfNativeInRule = tiers[0]?.tokens.indexOf('ETH');
  const indexofStarsPrice = tiers[0]?.tokens.indexOf('STARS');

  const ERC1155NativePrice =
    tkType === 'ERC1155 Mintable' ? tiers[0]?.prices[indexOfNativeInRule] : 0;
  const ERC1155StarsPrice =
    tkType === 'ERC1155 Mintable' ? tiers[0]?.prices[indexofStarsPrice] : 0;

  const nativePrice = ERC1155NativePrice || defaultNativePrice;

  const formatPrice = (value: number | string) => {
    if (typeof value === 'string') {
      return parseFloat(`${value}`);
    }

    return value;
  };

  const starsPrice: number =
    tkType === 'ERC1155 Mintable'
      ? formatPrice(ERC1155StarsPrice || simplifiedPrice)
      : defaultStarsPrice;

  const raised =
    props.preSales *
    (!isNaN(nativePrice)
      ? props.launchPadData?.collection?.network === 'MAINNET'
        ? nativePrice * ethToUsdRatio
        : nativePrice * bnbToUsdRatio
      : starsPrice * starsToUsdRatio);

  const targetSupply: string | number =
    props.launchPadData?.collection?.maxSupply ??
    props.launchPadData?.totalSupply ??
    0;

  const totalSupply: number =
    typeof targetSupply === 'string' ? parseFloat(targetSupply) : targetSupply;

  const maxQuantity: string =
    props.launchPadData?.collection?.maxQuantityGlobal ?? '1';

  return (
    <div>
      <div
        className={'flex justify-center items-center h-44'}
        style={{
          backgroundImage: `url(${props.launchPadData?.collection?.bannerImageUrl})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>

      <div className="flex flex-col justify-center items-center">
        <div className={'lg:w-8/12 sm:w-9/12 px-8 rounded-tl-lg rounded-tr-lg'}>
          <div
            className={
              styles.headerTitle + ' my-6 font-bold text-4xl break-words'
            }
          >
            {props.launchPadData?.collection?.name}
          </div>
          <div
            className={
              styles.headerDescription +
              ' mr-7 font-semibold text-sm break-words'
            }
          >
            {communityInfos.subHeader ?? ''}
          </div>
          <div className="md:mt-8 mt-6 mb-6">
            <Typography
              style={{
                color: '#FCD559',
                padding: '5px 30px',
                width: 'fit-content',
                fontSize: '14px',
                marginTop: '-10px',
                border: '2px solid #FCD559',
                textAlign: 'center',
              }}
            >
              Featured Launch
            </Typography>
          </div>
          {props.startDate.getTime() - new Date().getTime() > 0 ? (
            <div className="flex flex-start flex-wrap xl:mb-6 mb-6">
              <div className="xl:w-6/12 w-full font-semibold text-sm flex flex-col items-start">
                <div className={styles.dateLabel}>{dateLabel}</div>
                {dateLabel === 'Pre-Sale Start' ? (
                  <div>
                    {getMonthEnglish(props.preSaleDate.getMonth() + 1)}{' '}
                    {props.preSaleDate.getDate()},{' '}
                    {props.preSaleDate.getFullYear()} at{' '}
                    {getPrettyDayTime(props.preSaleDate)}
                    <LaunchpadCountDown
                      startDate={new Date(props.preSaleDate)}
                    />
                  </div>
                ) : (
                  <div>
                    {getMonthEnglish(props.startDate.getMonth() + 1)}{' '}
                    {props.startDate.getDate()}, {props.startDate.getFullYear()}{' '}
                    at {getPrettyDayTime(props.startDate)}
                    <LaunchpadCountDown startDate={new Date(props.startDate)} />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="flex flex-start flex-wrap xl:mb-6 mb-6">
              <div className="xl:w-6/12 w-full font-semibold text-sm flex flex-col items-start">
                <div className={styles.dateLabel}>{'Sale End'}</div>
                <div>
                  {getMonthEnglish(props.saleEndDate.getMonth() + 1)}{' '}
                  {props.saleEndDate.getDate()},{' '}
                  {props.saleEndDate.getFullYear()} at{' '}
                  {getPrettyDayTime(props.saleEndDate)}
                  <LaunchpadCountDown startDate={new Date(props.saleEndDate)} />
                </div>
              </div>
            </div>
          )}
          {whitelist.includes(walletInfo?.walletAddress) &&
          props.preSaleDate.getTime() - new Date().getTime() > 0 &&
          !isNaN(props.preSaleDate.getTime() - new Date().getTime()) ? (
            <div className={'flex items-center font-semibold text-sm'}>
              <img
                src={checkmarkCircle}
                width="12px"
                height="12px"
                alt="checkmarkCircle"
              />
              <div className={'font-semibold text-sm ml-2'}>
                Whitelist Spot Confirmed
              </div>
            </div>
          ) : props.preSaleDate.getTime() - new Date().getTime() > 0 &&
            !isNaN(props.preSaleDate.getTime() - new Date().getTime()) ? (
            <div className={'flex items-center font-semibold text-sm'}>
              <img
                src={multiplyCircle}
                width="12px"
                height="12px"
                alt="multiplyCircle"
              />
              <div className={'font-semibold text-sm ml-2'}>
                Wallet Address Not In Whitelist
              </div>
            </div>
          ) : null}
          <div className="flex flex-wrap lg:justify-start justify-center mt-2">
            <div className="xl:w-6/12 w-full">
              <div className="w-full flex flex-col xl:items-start items-center">
                <img
                  className={
                    styles.collectionPicCol + ' xl:w-10/12 w-full h-auto'
                  }
                  src={`${props.launchPadData?.collection?.logoImageUrl}`}
                  alt="collectionImage"
                />
                {!hideProgressBar ? (
                  <div className="w-full">
                    <div
                      className={
                        styles.collectionPicCol +
                        ' flex justify-around xl:w-10/12 w-full mt-4'
                      }
                    >
                      <div className="mt-2 font-semibold text-base">
                        Raised: ~
                        {raised.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{' '}
                        USD
                      </div>
                    </div>
                    <BorderLinearProgress
                      variant="determinate"
                      value={
                        totalSupply > 0
                          ? (props.preSales /
                              (totalSupply * parseFloat(maxQuantity))) *
                            100
                          : 0
                      }
                      className="xl:w-10/12 w-full mt-2"
                    />
                    <div
                      className={
                        styles.collectionPicCol +
                        ' flex justify-between xl:w-10/12 w-full'
                      }
                    >
                      <div className="mt-2 font-semibold text-sm">
                        {totalSupply > 0
                          ? (
                              (props.preSales /
                                (totalSupply * parseFloat(maxQuantity))) *
                              100
                            ).toPrecision(3)
                          : 0}
                        %
                      </div>
                      <div className="mt-2 font-semibold text-sm">
                        {props.preSales.toLocaleString()}/
                        {totalSupply > 0
                          ? (
                              totalSupply * parseFloat(maxQuantity)
                            ).toLocaleString()
                          : ''}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="xl:w-5/12 xl:ml-12 xl:mt-0 mt-10 mb-14 w-full flex flex-col xl:items-start items-center">
              <div className="flex w-full xl:justify-start justify-center">
                {communityInfos.discord ? (
                  <a
                    className={
                      styles.socialIcon +
                      ' flex justify-center items-center h-10 w-10 mr-6'
                    }
                    href={communityInfos.discord}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="h-6 w-6"
                      src={discordIcn}
                      alt="discordIcon"
                    />
                  </a>
                ) : null}
                {communityInfos.twitter ? (
                  <a
                    className={
                      styles.socialIcon +
                      ' flex justify-center items-center h-10 w-10 mr-6'
                    }
                    href={communityInfos.twitter}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="h-6 w-6"
                      src={twitterIcn}
                      alt="twitterIcon"
                    />
                  </a>
                ) : null}
                {communityInfos.website ? (
                  <a
                    className={
                      styles.socialIcon +
                      ' flex justify-center items-center h-10 w-10 mr-6'
                    }
                    href={communityInfos.website}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img className="h-6 w-6" src={globeIcn} alt="globeIcon" />
                  </a>
                ) : null}
              </div>
              <p className="text-sm mt-4 whitespace-pre-line">
                {props.launchPadData?.collection?.description}
              </p>
              <div className="flex flex-col w-full">
                <div className="font-semibold text-sm mt-10 w-full">
                  {props.startDate.getTime() - new Date().getTime() > 0
                    ? `Pre-Sale Mint${
                        tkType === 'ERC1155 Mintable' &&
                        pricingStrategy === 'Tiered'
                          ? ' (Starts At)'
                          : ''
                      }:`
                    : props.startDate.getTime() - new Date().getTime() < 0 &&
                      props.saleEndDate.getTime() - new Date().getTime() > 0
                    ? `Public Mint${
                        tkType === 'ERC1155 Mintable' &&
                        pricingStrategy === 'Tiered'
                          ? ' (Starts At)'
                          : ''
                      }:`
                    : 'Sale Ended'}
                </div>
                {!saleEnd && (
                  <div
                    className={
                      styles.mintPrice +
                      ' flex xlg: mt-6 -ml-2 items-center font-semibold'
                    }
                  >
                    {(paymentPrices ?? []).map((price: any, index: number) => {
                      if ((paymentCurrencies ?? [])[index] === 'ETH') {
                        return (
                          <div className="flex items-center mx-3" key={index}>
                            <img
                              className="h-8 w-7 mr-2"
                              src={ethIcn}
                              alt="ethIcon"
                            />
                            {`${price.toLocaleString()} ETH`}
                          </div>
                        );
                      } else if ((paymentCurrencies ?? [])[index] === 'BNB') {
                        return (
                          <div className="flex items-center mx-3" key={index}>
                            <BSCIcn className="h-5 w-5 mr-2" fill="gold" />
                            {`${price.toLocaleString()} BNB`}
                          </div>
                        );
                      } else if ((paymentCurrencies ?? [])[index] === 'STARS') {
                        return (
                          <div
                            className="flex items-center ml-2 relative"
                            key={index}
                          >
                            <img
                              className={styles.stars + ' h-5 w-5 mr-3'}
                              src={starsIcn}
                              alt="starsIcon"
                            />
                            <p
                              className={
                                styles.saving +
                                ' absolute -top-4 left-7 ml-1 font-thin'
                              }
                            >
                              Save 5%
                            </p>
                            {price.toLocaleString()} MOGUL
                          </div>
                        );
                      } else {
                        return (
                          <div className="flex items-center mx-3" key={index}>
                            {`${price.toLocaleString()} ${
                              props.launchPadData?.currency[index] ?? ''
                            }`}
                          </div>
                        );
                      }
                    })}
                  </div>
                )}
                {dropStart && !saleEnd && (
                  <div className="flex items-center">
                    <div
                      className={
                        styles.button +
                        ' flex justify-center items-center mt-5 mr-5'
                      }
                    >
                      <div
                        role="button"
                        aria-hidden
                        className={styles.mintOperation + ' mb-1 mr-5'}
                        onClick={decreaseAmount}
                      >
                        -
                      </div>
                      <div className={styles.mintText}>{mintAmount}</div>
                      <div
                        role="button"
                        aria-hidden
                        className={styles.mintOperation + ' mb-1 ml-5'}
                        onClick={increaseAmount}
                      >
                        +
                      </div>
                    </div>
                    <Button
                      variant="contained"
                      disableElevation
                      color="primary"
                      style={{
                        borderWidth: '3px',
                        borderRadius: '4rem',
                        lineHeight: '18px',
                        height: '34px',
                        width: '160px',
                        fontSize: '16px',
                        marginTop: '18px',
                        fontWeight: 'bold',
                      }}
                      onClick={mint}
                    >
                      MINT
                    </Button>
                  </div>
                )}
                {!dropStart && !saleEnd && (
                  <Button
                    variant="outlined"
                    style={{
                      border: '#fcd559 3px solid',
                      borderWidth: '3px',
                      borderRadius: '4rem',
                      lineHeight: '18px',
                      width: '200px',
                      fontSize: '16px',
                      marginTop: '18px',
                      fontWeight: 'bold',
                      color: '#FCD559',
                    }}
                    className={styles.notificationHover}
                    onClick={notify}
                  >
                    <img
                      className="h-12 w-12 -my-3 -ml-4"
                      src={notifIcn}
                      alt="notifIcn"
                    ></img>
                    GET NOTIFIED
                  </Button>
                )}
                <div className={styles.buttonContainer}>
                  <CoreButton
                    onClick={viewCollection}
                    className="w-full mr-2"
                    label={'View Collection'}
                  />
                  <CoreButton
                    onClick={goToMarketplace}
                    className={styles.marketPlaceButton + ' w-full ml-2'}
                    label={'Marketplace'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
